export default __webpack_public_path__ + "static/media/arrowUp.dc1c3fda.svg";